// ===========================================
// MOCK DATA - Fixwell Fasteners
// Easy to update with real data later
// ===========================================

export const brandData = {
  brand_name: "Fixwell Fasteners",
  legal_name: "Fixwell Private Limited",
  tagline: "Precision Fastening Solutions",
  positioning_phrase: "Cold Forged Fasteners"
};

export const images = {
  hero: "https://images.unsplash.com/photo-1717386255773-1e3037c81788?w=1600&q=80",
  heroAlt: "Modern automated manufacturing plant",
  factory: "https://images.unsplash.com/photo-1647427060118-4911c9821b82?w=800&q=80",
  factoryAlt: "Automated robotic assembly line",
  products: "https://images.pexels.com/photos/3930093/pexels-photo-3930093.jpeg?w=800&q=80",
  productsAlt: "Various metal fasteners and hardware",
  fasteners: "https://images.pexels.com/photos/207367/pexels-photo-207367.jpeg?w=800&q=80",
  fastenersAlt: "Close-up of metal bolts",
  machinery: "https://images.pexels.com/photos/50691/drill-milling-milling-machine-drilling-50691.jpeg?w=800&q=80",
  machineryAlt: "CNC drilling machine",
  welding: "https://images.unsplash.com/photo-1455165814004-1126a7199f9b?w=800&q=80",
  weldingAlt: "Industrial manufacturing process",
  lab: "https://images.pexels.com/photos/9574449/pexels-photo-9574449.jpeg?w=800&q=80",
  labAlt: "Quality control laboratory",
  quality: "https://images.pexels.com/photos/3992935/pexels-photo-3992935.jpeg?w=800&q=80",
  qualityAlt: "Precision testing equipment"
};

export const aboutData = {
  summary_points: [
    "Leading manufacturer of high-quality fastening solutions for India's top brands.",
    "Precision-engineered components trusted by OEMs and Tier-1 suppliers across industries.",
    "Advanced technology, skilled manpower, and a state-of-the-art facility.",
    "Legacy of over 45 years.",
    "Extensive catalog of over 10 products.",
    "All products manufactured in-house.",
    "Daily production capacity exceeding one million pieces."
  ],
  named_customers: ["Havells", "Paytm", "V-Guard", "Exide", "Su Kam"]
};

export const facilityData = {
  location: "Bulandshahr Road Industrial Area",
  total_area_sqft: 30000,
  built_up_area_sqft: 12000,
  commercial_production_started_year: 1981
};

export const qualityPolicy = [
  "Continually enhance quality management system.",
  "Manufacture and supply defect-free fasteners and precision-engineered components meeting customer needs and expectations.",
  "Employee involvement, motivation, and skill enhancement via regular training programs.",
  "Strict adherence to quality management standards and continual process improvement.",
  "Deliver reliable, high-performance fastening solutions every time."
];

export const qualityTestingLab = [
  "Micrometer",
  "Vernier Caliper",
  "Hardness Testing",
  "Thread Depth Gauge",
  "Profile Projector",
  "Plating Micron Testing Machine",
  "Salt Spray Testing Chambers"
];

export const manufacturingCapabilities = {
  precision_machines: [
    { name: "Headers", qty: 25 },
    { name: "Threading Machine", qty: 14 },
    { name: "Slotting Machine", qty: 8 },
    { name: "Rotary Furnace", qty: 1 },
    { name: "Tempering Furnace", qty: 1 }
  ],
  plating_setup: [
    { name: "Plating Barrels", qty: 10 },
    { name: "Cleansing Barrels", qty: 4 },
    { name: "Polishing Barrels", qty: 3 }
  ],
  rectifiers_setup: [
    { name: "1000 A Rectifier", qty: 1 },
    { name: "500 A Rectifier", qty: 1 },
    { name: "300 A Rectifier", qty: 2 }
  ],
  support_equipment: [
    { name: "Chiller Plant (3 Ton)", qty: 1 },
    { name: "Chemical Filtration Pumps", qty: 5 },
    { name: "Centrifugal Dryers", qty: 3 },
    { name: "Box Stitching Machine", qty: 1 },
    { name: "Lathe", qty: 1 },
    { name: "Surface Grinder", qty: 2 },
    { name: "Hydraulic Jack", qty: 1 },
    { name: "Power Hexa", qty: 1 },
    { name: "Hardness Tester", qty: 3 }
  ]
};

export const processFlow = {
  steps: [
    { step: 1, name: "Heading", description: "Cold Forging" },
    { step: 2, name: "Slotting", description: "Screw head slotting (if no Philips cross recess)" },
    { step: 3, name: "Threading", description: "Thread rolling (thread forming)" },
    { step: 4, name: "Heat Treatment", description: "For self-tapping screws" },
    { step: 5, name: "Electro Plating", description: "Surface finishing" },
    { step: 6, name: "Quality Check", description: "Final inspection" }
  ],
  scope: "Manufacturing of Precise and Customized Fastening Solutions"
};

export const products = [
  { 
    name: "Philip Head", 
    category: "Standard", 
    description: "Cross-recessed screws for general applications",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/3p6di855_01_01_philip_head.png"
  },
  { 
    name: "Philip Head Combo", 
    category: "Standard", 
    description: "Combination head for versatile use",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/bi1hf0o0_01_02_philip_head_combo.png"
  },
  { 
    name: "Philip Head Washer", 
    category: "Standard", 
    description: "Built-in washer for secure fastening",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/5w61h0q0_01_03_philip_head_washer.png"
  },
  { 
    name: "AB Type Screws", 
    category: "Self-Tapping", 
    description: "Sharp point for sheet metal",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/hggyu8iq_02_01_ab_type_screws.png"
  },
  { 
    name: "Philip CSK", 
    category: "Standard", 
    description: "Countersunk for flush finish",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/9ky1iz06_02_02_philip_csk.png"
  },
  { 
    name: "B Type Screws", 
    category: "Self-Tapping", 
    description: "Blunt point tapping screws",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/qb4bbxv7_02_03_b_type_screws.png"
  },
  { 
    name: "BT Type Screws", 
    category: "Self-Tapping", 
    description: "Thread-cutting design",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/x7mocwov_03_01_bt_type_screws.png"
  },
  { 
    name: "Hex Bolt Screws", 
    category: "Industrial", 
    description: "Heavy-duty hex head fasteners",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/k1icvp1s_03_02_hex_bolt_screws.png"
  },
  { 
    name: "U Type", 
    category: "Specialty", 
    description: "U-shaped specialty fasteners",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/j0dkvgfc_03_03_u_type.png"
  },
  { 
    name: "Terminal Screws", 
    category: "Industrial", 
    description: "Electrical terminal applications",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/imydcf5k_04_01_terminal_screws.png"
  },
  { 
    name: "Cheese Head Screws", 
    category: "Standard", 
    description: "Cylindrical head for machine use",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/d17ub52b_04_02_cheese_head_screws.png"
  },
  { 
    name: "Hex Bolt with Washer", 
    category: "Industrial", 
    description: "Integrated washer for load distribution",
    image: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/ongswxr5_04_03_hex_bolt_with_washer.png"
  }
];

export const trustedByLogos = [
  { 
    name: "Luminous",
    logo: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/zvs81emh_1.svg"
  },
  { 
    name: "Havells",
    logo: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/imx4mf8r_2.svg"
  },
  { 
    name: "Morphy Richards",
    logo: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/ixjv9w52_3.svg"
  },
  { 
    name: "Philips",
    logo: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/snj20sk7_4.svg"
  },
  { 
    name: "Paytm",
    logo: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/py0hlum2_5.svg"
  },
  { 
    name: "V-Guard",
    logo: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/tgayjkjx_6.svg"
  },
  { 
    name: "Exide",
    logo: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/x1pieldd_7.svg"
  },
  { 
    name: "Compact",
    logo: "https://customer-assets.emergentagent.com/job_6d905f60-0135-4912-9088-a94c9d330ff7/artifacts/3hvu5ik8_8.svg"
  }
];

export const contacts = [
  {
    name: "Chirag Vasudeva",
    title: "Director",
    phone: "+91 8586979010",
    email: "chirag@fixwellfastenersindia.com"
  },
  {
    name: "Arpan Aneja",
    title: "Director",
    phone: "+91 9891469000",
    email: "arpan@fixwellfastenersindia.com"
  },
  {
    name: "Daksh Maheshwari",
    title: "Director",
    phone: "+91 9990698236",
    email: "daksh@fixwellfastenersindia.com"
  }
];

export const stats = [
  { value: "45", suffix: "+", label: "Years of Excellence" },
  { value: "1M", suffix: "+", label: "Daily Production" },
  { value: "30K", suffix: "", label: "Sq. Ft. Facility" },
  { value: "12", suffix: "+", label: "Product Types" }
];

export const resources = [
  {
    id: "catalog",
    title: "Product Catalog",
    description: "Complete catalog of all fastener types with specifications",
    type: "Catalog",
    available: false
  },
  {
    id: "capabilities",
    title: "Capabilities Sheet",
    description: "Detailed overview of our manufacturing capabilities and capacity",
    type: "Capabilities",
    available: false
  },
  {
    id: "quality",
    title: "Quality Statement",
    description: "Our quality policy, certifications, and testing procedures",
    type: "Quality",
    available: false
  },
  {
    id: "packaging",
    title: "Packaging & Dispatch",
    description: "Information about packaging options and shipping procedures",
    type: "Other",
    available: false
  }
];

export const productCategories = [
  "Philip Head",
  "Philip Head Combo", 
  "Philip Head Washer",
  "AB Type Screws",
  "Philip CSK",
  "B Type Screws",
  "BT Type Screws",
  "Hex Bolt Screws",
  "U Type",
  "Terminal Screws",
  "Cheese Head Screws",
  "Hex Bolt with Washer",
  "Other / Not Sure"
];